import type { FC } from 'react';
import React from 'react';

import upperFirst from 'lodash.upperfirst';

import type { IconProps } from './Icon';
import { Icon } from './Icon';
import { cnIcon } from './Icon.cn';

export const createIcon = (iconName: string, IconSvg: FC) => {
    const Component: FC<IconProps> = ({ className, size = 'm', ...restProps }) => {
        return (
            <Icon
                data-icon={iconName}
                {...restProps}
                size={size}
                className={cnIcon({ sizeManagement: 'self', hasGlyph: true, newFormat: true }, [
                    className,
                ])}
            >
                <IconSvg />
            </Icon>
        );
    };

    Component.displayName = `${upperFirst(iconName)}Icon`;

    return Component;
};
